export enum DynamicLabelType {
    ListName = "LIST_NAME",
    ListCode = "LIST_CODE",
    ListId = "LIST_ID",
    LastUpdated = "LAST_UPDATED",
}
